// Curated "trail" itineraries — config-driven so new trails are a data change.
export const TRAILS = {
  "wine-beer": {
    slug: "wine-beer",
    title: "The CSRA Wine & Beer Trail",
    eyebrow: "Curated date night",
    icon: "wine",
    accent: "#7A1F2B",
    subtitle:
      "A hand-picked crawl through the region's best wine bars, vineyards and taprooms — from a candlelit first pour to a laid-back nightcap.",
    hero: "https://images.unsplash.com/photo-1645518044896-a3cbba9afb57?crop=entropy&cs=srgb&fm=jpg&q=85",
    keywords: ["wine", "winery", "vineyard", "brewery", "beer", "taproom", "tap"],
    order: [
      "solo-vino-marchand-de-vin", "craft-vine", "wine-dine", "three-star-vineyard-and-orchard",
      "stillwater-taproom", "savannah-river-brewing-co", "arsenal-tap-room-and-kitchen",
      "good-girl-brewing-co", "aiken-brewing-company",
    ],
    slots: ["First pour", "Second stop", "Golden hour", "Nightcap", "One more round"],
    metaLeft: "Wine bars & vineyards",
    metaRight: "Local taprooms",
    exploreLink: "/explore?category=Food%20%26%20Drink",
    // wine vs beer icon per stop
    altKeywords: ["wine", "winery", "vineyard", "cellar"],
  },
  "coffee-crawl": {
    slug: "coffee-crawl",
    title: "The CSRA Coffee Crawl",
    eyebrow: "Slow morning",
    icon: "coffee",
    accent: "#6F4E37",
    subtitle:
      "Local roasters, cozy cafés and fresh-baked pastries — the tastiest way to wake up and wander across the CSRA.",
    hero: "https://images.unsplash.com/photo-1511081692775-05d0f180a065?crop=entropy&cs=srgb&fm=jpg&q=85",
    keywords: ["coffee", "cafe", "café", "espresso", "roast", "bakery"],
    order: [
      "new-moon-cafe-aiken", "buona-caffe", "commander-coffee", "trellis-coffee-bar",
      "emils-augusta", "new-moon-cafe-augusta",
    ],
    slots: ["First cup", "Mid-morning", "Pastry stop", "One more shot", "Afternoon pick-me-up"],
    metaLeft: "Local roasters",
    metaRight: "Cozy cafés",
    exploreLink: "/explore?category=Food%20%26%20Drink",
  },
  "kid-friendly-day": {
    slug: "kid-friendly-day",
    title: "Kid-Friendly Day",
    eyebrow: "Family fun",
    icon: "baby",
    accent: "#1F7A8C",
    subtitle:
      "A full day the whole crew will love — playgrounds, hands-on museums, gardens to roam and wide-open parks.",
    hero: "https://images.unsplash.com/photo-1630139026564-4a2bf5670879?crop=entropy&cs=srgb&fm=jpg&q=85",
    keywords: ["kids", "family-fun", "playground", "arcade", "pinball", "indoor-play"],
    order: [
      "playland-of-aiken", "hopelands-gardens-2", "radioactive-pinball-arcade",
      "virginia-acres-park", "aiken-center-for-the-arts", "aiken-county-farmers-market",
    ],
    slots: ["Morning play", "Late morning", "Lunch & run-around", "Afternoon adventure", "Wind down"],
    metaLeft: "Playgrounds & parks",
    metaRight: "Hands-on fun",
    exploreLink: "/explore?tag=family-fun",
  },
  "outdoors-adventure": {
    slug: "outdoors-adventure",
    title: "The Outdoors & Adventure Trail",
    eyebrow: "Fresh air",
    icon: "mountain",
    accent: "#2F6B3C",
    subtitle:
      "Sandy woodland trails, blackwater paddles, hilltop gardens and wide-open state parks — a full day in the CSRA outdoors.",
    hero: "https://images.unsplash.com/photo-1761419772686-6d23f48ee973?crop=entropy&cs=srgb&fm=jpg&q=85",
    keywords: ["outdoors", "hiking", "paddling", "trail", "gardens", "nature", "fishing", "park"],
    order: [
      "hitchcock-woods", "hopelands-gardens", "carolina-bay-nature-preserve", "boyd-pond-park",
      "north-augusta-greeneway", "langley-pond-park", "aiken-state-park",
    ],
    slots: ["Morning hike", "Garden stroll", "Nature break", "Afternoon paddle", "Sunset overlook"],
    metaLeft: "Trails & parks",
    metaRight: "Nature & water",
    exploreLink: "/explore?category=Outdoors",
  },
  "live-music-night": {
    slug: "live-music-night",
    title: "Live Music Night",
    eyebrow: "After dark",
    icon: "music",
    accent: "#5B2A86",
    subtitle:
      "Grand theaters, downtown bars and brewery stages — chase the best live sound across the CSRA from dinner to the last set.",
    hero: "https://images.unsplash.com/photo-1619229665876-f54b2276b7bd?crop=entropy&cs=srgb&fm=jpg&q=85",
    keywords: ["live-music", "concert", "music", "theater", "symphony", "amphitheater", "stage"],
    order: [
      "stillwater-taproom", "whiskey-alley", "the-alley", "good-girl-brewing-co",
      "miller-theater", "savannah-river-brewing-co", "stable-view",
    ],
    slots: ["Dinner & drinks", "Opening act", "Main stage", "Late set", "Nightcap"],
    metaLeft: "Stages & venues",
    metaRight: "Bands & bars",
    exploreLink: "/explore?tag=live-music",
  },
};

export const TRAIL_LIST = [
  TRAILS["wine-beer"],
  TRAILS["coffee-crawl"],
  TRAILS["kid-friendly-day"],
  TRAILS["outdoors-adventure"],
  TRAILS["live-music-night"],
];
